import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'

const RepaymentOpExpensesModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted, status,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  opExpenseDate, onOpExpenseDateChange, opExpenseDateError, setOpExpenseDateError,
  opExpense, onOpExpenseChange, opExpenseError, setOpExpenseError,
  opExpenseRemarks, onOpExpenseRemarksChange, opExpenseRemarksError, setOpExpenseRemarksError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Add OOP Expense'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputDateUI context={context} name='opExpensedate' label='Expense date'
          selectedDateISO={opExpenseDate} onChange={onOpExpenseDateChange}
          error={opExpenseDateError} setError={setOpExpenseDateError}
    />
    <InputTextSF type='text' name='opExpense' label='Out of pocket expense'
      value={opExpense} onChange={onOpExpenseChange}
      error={opExpenseError} setError={setOpExpenseError}
    />
    <InputTextSF type='text' name='opExpenseRemarks' label='Remarks for out of pocket expense'
      value={opExpenseRemarks} onChange={onOpExpenseRemarksChange}
      error={opExpenseRemarksError} setError={setOpExpenseRemarksError}
      help='Shown to client'
    />

  </ModalFormUI>

export default RepaymentOpExpensesModalUI
